import { render, staticRenderFns } from "./SandboxesDialog.vue?vue&type=template&id=def23934&"
import script from "./SandboxesDialog.vue?vue&type=script&lang=js&"
export * from "./SandboxesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports